export default __webpack_public_path__ + "static/media/subject-history.72593254.webp";